// extracted by mini-css-extract-plugin
export var checkoutContainer = "delivery-banner-module--checkoutContainer--a35b8";
export var container = "delivery-banner-module--container--4b4e9";
export var content = "delivery-banner-module--content--e0467";
export var header = "delivery-banner-module--header--a165a";
export var icon = "delivery-banner-module--icon--5f777";
export var nextDayText = "delivery-banner-module--nextDayText--936e6";
export var nextDayTime = "delivery-banner-module--nextDayTime--d561d";
export var textWrapper = "delivery-banner-module--textWrapper--483ba";